import type { FC } from 'react';
import React, { useMemo } from 'react';

import { Size } from '../types';
import { Wrapper } from './Counter.styled';

const MAX_NUMBER = 99;

interface CounterProps {
  number: number;
  disabled?: boolean;
  isPrimary?: boolean;
  onClick?: () => void;
  showPlusSign?: boolean;
  size?: Size;
}

const Counter: FC<CounterProps> & { Size: typeof Size } = ({
  number,
  disabled,
  isPrimary = true,
  onClick,
  showPlusSign = false,
  size = Size.MEDIUM,
}) => {
  const displayNumber = useMemo(() => {
    if (showPlusSign) {
      return `+${number}`;
    }

    return number < MAX_NUMBER ? number : `+${MAX_NUMBER}`;
  }, [number, showPlusSign]);

  return (
    <Wrapper $disabled={disabled} onClick={onClick} $isPrimary={isPrimary} $size={size}>
      {displayNumber}
    </Wrapper>
  );
};

Counter.Size = Size;

export default Counter;
